/**
 * ProductDashboardContainer
 *
 *
 */

import React, { useState, useEffect } from 'react';
import ProductDashboardPresenter from './ProductDashboardPresenter';
import MessageAlert from 'utils';
import { StatisticsApi } from 'api';
import dayjs from 'dayjs';
// import moment from 'moment';

/**----------------------------------------
 * [Component] 총관리자: 장바구니 분석 - 컨테이너
 * ----------------------------------------
 */
const ProductDashboardContainer = ({ defaultShopId, permission }) => {
  /* ===== INIT ===== */
  /* ===== STATE ===== */
  const [currentShop, _setCurrentShop] = useState(defaultShopId ?? null);
  const [statisticsType, setStatisticsType] = useState('month');
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);
  /* ===== VARIABLE ===== */

  /* ===== FUNCTION ===== */
  /**
   * 데이터 조회
   * --
   */
  const getData = async (type) => {
    setLoading(true);
    try {
      const { status, message, data } = await StatisticsApi.getStatistics(
        `product-dashboard`,
        {
          ...(currentShop && { shopId: currentShop }),
        }
      );
      if (status !== 200) throw { message };

      setTimeout(() => {
        setData(data);
        setLoading(false);
      }, 850);
    } catch (e) {
      setLoading(false);
      console.log('[UserDashboardContainer][getData] Error: ', e);
      MessageAlert.error(e.message);
    }
  };

  /* ===== HOOKS ===== */
  useEffect(() => {
    getData();
  }, []);

  /* ===== RENDER ===== */
  const props = {
    loading,
    data,
    permission,
    currentShop,
    statisticsType,
    setStatisticsType,
  };
  // JSX: start
  return (
    <>
      <ProductDashboardPresenter {...props} />
    </>
  ); // JSX: end
};

ProductDashboardContainer.defaultProps = {
  defaultShopId: null,
  permission: 'ADMIN',
};
export default ProductDashboardContainer;
